import React, { useState } from "react";
import styles from "./AddLabel.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import { FaUsers } from "react-icons/fa";

const AddLabel = () => {
  const [LabelName, setLabelName] = useState("");
  const dispatch = useDispatch();

  const handleSave = () => {
    if (LabelName.trim()) {
      console.log("Label Created:", LabelName);
      dispatch(closeModal());
    } else {
      alert("Please enter a Label name.");
    }
  };
  const handleClose = () => {
    dispatch(closeModal());};
  const handleCancel = () => {
    setLabelName("");
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaUsers />} heading="Label Details" />
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.body}>
        <HeadingAndData
          label="Label Name"
          name="labelName"
          placeholder="Enter Label name"
          value={LabelName}
          onChange={(e) => setLabelName(e.target.value)}
          required
        />

        <div className={styles.actions}>
          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default AddLabel;
